var chunkMapping = {
	"119": [
		3119
	],
	"389": [
		4389
	],
	"432": [
		3677
	],
	"583": [
		4583
	],
	"610": [
		610
	],
	"666": [
		3069,
		242,
		1496,
		7653,
		254
	],
	"680": [
		9680
	],
	"704": [
		2704
	],
	"761": [
		761
	],
	"776": [
		7776
	],
	"981": [
		9981
	]
};
var idToExternalAndNameMapping = {
	"242": [
		"default",
		"./List",
		2038
	],
	"254": [
		"default",
		"./icons/Document",
		2038
	],
	"610": [
		"default",
		"./Carousel",
		2038
	],
	"761": [
		"default",
		"./Card",
		2038
	],
	"1496": [
		"default",
		"./ListItem",
		2038
	],
	"2704": [
		"default",
		"./Icon",
		2038
	],
	"3069": [
		"default",
		"./Avatar",
		2038
	],
	"3119": [
		"default",
		"./Button",
		2038
	],
	"3677": [
		"default",
		"./Selectors",
		4403
	],
	"4389": [
		"default",
		"./Link",
		4403
	],
	"4583": [
		"default",
		"./Col",
		2038
	],
	"7653": [
		"default",
		"./ListItemMeta",
		2038
	],
	"7776": [
		"default",
		"./Text",
		2038
	],
	"9680": [
		"default",
		"./Row",
		2038
	],
	"9981": [
		"default",
		"./Image",
		2038
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}